module.exports = __webpack_public_path__ + "img/strom1.5da19a47.png";